import * as tf from '@kemtai/mini-tfjs'
//import * as tf from '@tensorflow/tfjs'
export  {tf}


